import { render, staticRenderFns } from "./v1_mobile.vue?vue&type=template&id=f21ea978&scoped=true&style=background-color%3A%20%23f4f5f7&"
import script from "./v1_mobile.vue?vue&type=script&lang=js&"
export * from "./v1_mobile.vue?vue&type=script&lang=js&"
import style0 from "./v1_mobile.vue?vue&type=style&index=0&id=f21ea978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21ea978",
  null
  
)

export default component.exports